import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { PatientjourneyService } from '../../_service/patientjourney.service';
import { SharedService } from '../../_service/shared.service';
@Component({
  selector: 'app-patient-journey-city-wise',
  templateUrl: './patient-journey-city-wise.component.html',
  styleUrls: ['./patient-journey-city-wise.component.css']
})
export class PatientJourneyCityWiseComponent implements OnInit {

  constructor(private sharedapi:SharedService, private patientjourneyapi:PatientjourneyService) { }
  IpdData:any=[];todayDate:any='--/--/----';loaded:boolean=false;loading:boolean=true;total_admission = 0;
  total_admission_done = 0;total_ot = 0;total_ot_done = 0;total_discharges = 0;total_discharges_done = 0;
  currentTime:any='--:--';
  ngOnInit(): void {
  }
  ngAfterViewInit() {
    this.getCityWise();
  }

  getCityWise() {
    this.loading = true;
    this.loaded = false;
    this.patientjourneyapi.getCityWisePatientjourney().subscribe((data:any) => {
      this.loading = false;
      this.loaded = true;
      if(data.status)
      {
        this.IpdData = data.data;
        this.todayDate = data.today_date;
        this.currentTime = data.current_time;
        this.total_admission = data.total_admission;
        this.total_admission_done = data.total_admission_done;
        this.total_ot = data.total_ot;
        this.total_ot_done = data.total_ot_done;
        this.total_discharges = data.total_discharges;
        this.total_discharges_done = data.total_discharges_done;
      }
      else
      {
        this.IpdData = [];
        this.todayDate = '--/--/----';
        this.currentTime = '--:--';
        this.total_admission = 0;
        this.total_admission_done = 0;
        this.total_ot = 0;
        this.total_ot_done = 0;
        this.total_discharges = 0;
        this.total_discharges_done = 0;
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
        this.loading = false;
        this.loaded = true;
        this.sharedapi.checkError(error);
    });
  }

}
